import { render, staticRenderFns } from "./CadastroFormacao.vue?vue&type=template&id=83d724dc&scoped=true"
import script from "./CadastroFormacao.vue?vue&type=script&lang=js"
export * from "./CadastroFormacao.vue?vue&type=script&lang=js"
import style0 from "./CadastroFormacao.vue?vue&type=style&index=0&id=83d724dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d724dc",
  null
  
)

export default component.exports